export default {"src":"/_next/static/media/free_parking_on_street.f77177ef.svg","height":100,"width":100};